<template>
  <div>
    <month-picker
      v-model="periodo"
      @periodo="onPeriodoChange"
    ></month-picker>
  </div>
</template>

<script>
import MonthPicker from '@/components/MonthPicker'
export default {
  name: 'PeriodoSelectComponent',
  components: {
    'month-picker': MonthPicker,
  },
  model: {
    prop: 'selected',
    event: 'change'
  },
  data () {
    return {
      periodo: null,
      fechaFrom: null,
      fechaTo: null,
    }
  },
  created () {
    // this.fechaActual = this.$moment();// Obtener el año y mes actual
  },
  computed: {
    selectedLocal: {
      get () {
        return this.selected
      },
      set (value) {
        const aux = value && value.id > 0 ? value.id : null
        this.setSelected(value)
      }
    },
  },
  watch: {
    //
  },
  methods: {
    async onPeriodoChange (newValue) {
      this.fechaFrom = newValue.from
      this.fechaTo = newValue.to
      this.$root.$emit('update:bono_periodo')
    },
  }
}
</script>
